import { Injectable, signal, effect, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  /** True when the app is in dark mode. Backed by localStorage under the key 'theme'. */
  darkMode = signal<boolean>(true);

  constructor() {
        const saved = localStorage.getItem('theme');
    // Honour explicit user choice; default to dark mode when there is no saved preference.
    const prefersDark = saved ? saved === 'dark' : true;
    this.darkMode.set(prefersDark);
    this._applyClass(prefersDark);

    // Keep DOM class and localStorage in sync whenever the signal changes.
    effect(() => {
      const isDark = this.darkMode();
            this._applyClass(isDark);
      localStorage.setItem('theme', isDark ? 'dark' : 'light');
    });
  }

  toggleTheme(): void {
    this.darkMode.update((d) => !d);
  }

  /** Adds or removes the 'dark' class on <html> — consumed by both Tailwind dark: utilities
   *  and the admin layout's :root.dark CSS-variable overrides. */
  private _applyClass(isDark: boolean): void {
    document.documentElement.classList.toggle('dark', isDark);
  }
}
